// Main content sections are groups of blocks and correlate to nav items
export const SECTIONS = {
    AMENITIES: 'amenities',
    CHAT_UI: 'chat-ui',
    HOST: 'host',
    INLINE_VIRTUAL_TOUR: 'inline-virtual-tour',
    MAP: 'map',
    MIDPAGE_RECO_CAROUSEL: 'midpage-reco-carousel',
    OTHER_UNITS: 'other-units', // multiunit section
    OVERVIEW: 'overview',
    POLICIES: 'policies',
    RATES_AVAILABILITY: 'rates-availability',
    REVIEWS: 'reviews',
    ROOMS_AND_SPACES: 'rooms-and-spaces'
};

// All available blocks to be composed into main sections (desktop and mobile)
export const BLOCKS = {
    ABOUT_THE_PROPERTY: 'about-the-property',
    AMENITIES: 'amenities',
    AUTH_CARD: 'auth-card',
    BEAR_STAY_BANNER: 'bear-stay-banner',
    BOOKING_ASSISTANCE: 'booking-assistance',
    CANCELLATION_POLICY: 'cancellation-policy',
    CHAT_UI: 'chat-ui',
    CIVIL_CODE_DISCLAIMER: 'civil-code-disclaimer',
    CLEANING_PRACTICES: 'cleaning-practices',
    DAMAGE_POLICY: 'damage-policy',
    FREE_CANCELLATION: 'free-cancellation',
    HOUSE_RULES: 'house-rules',
    INLINE_GLOBAL_MESSAGE: 'inline-global-message',
    INLINE_VIRTUAL_TOUR: 'inline-virtual-tour',
    MAP: 'map',
    MIDPAGE_RECO_CAROUSEL: 'midpage-reco-carousel',
    OTHER_UNITS: 'other-units',
    OWNER_DETAILS: 'owner-details',
    OWNER_DETAILS_MINI: 'owner-details-mini',
    RATES_AVAILABILITY_CALENDAR: 'rates-availability-calendar',
    REVIEWS: 'reviews',
    ROOMS_AND_SPACES: 'rooms-and-spaces',
    TRIP_DETAILS: 'trip-details',
    TRIP_LINK: 'trip-link'
};

// 1:1 of all arms from MAB to PDP sections. Eventually we can rename all sections to
// follow the same names defined in https://confluence.expedia.biz/display/VT/Property+Content+MAB+-+Content+Rules
// to avoid duplication like this. Trying to keep this simple for now
export const MAB_SECTION_MAP = {
    amenities: SECTIONS.AMENITIES,
    availability: SECTIONS.RATES_AVAILABILITY,
    host: SECTIONS.HOST,
    map: SECTIONS.MAP,
    policies: SECTIONS.POLICIES,
    reviews: SECTIONS.REVIEWS,
    'rooms_&_beds#virtual_tour': SECTIONS.ROOMS_AND_SPACES,
    'similar_properties#popular_destinations': SECTIONS.MIDPAGE_RECO_CAROUSEL,
    virtual_assistant: SECTIONS.CHAT_UI
};

// MAB mocked response to be used by dummy service while integration is not ready.
// It's also used by the intenal tools as a configuration template when editing the layout
export const MOCKED_MAB_ORDER = {
    order: [
        {
            categoryName: '2',
            level: 'virtual_assistant'
        },
        {
            categoryName: '9',
            level: 'availability'
        },
        {
            categoryName: '3',
            level: 'amenities'
        },
        {
            categoryName: '4',
            level: 'host'
        },
        {
            categoryName: '7',
            level: 'policies'
        },
        {
            categoryName: '8',
            level: 'similar_properties#popular_destinations'
        },
        {
            categoryName: '5',
            level: 'rooms_&_beds#virtual_tour'
        },
        {
            categoryName: '6',
            level: 'map'
        },
        {
            categoryName: '10',
            level: 'reviews'
        }
    ]
};
